import "../styles/index.scss";
import "slick-carousel/slick/slick.min.js";
import "slick-carousel/slick/slick.scss";
import "@benmajor/jquery-touch-events";

import accordion from './accordion.js';
import appbarHamburger from './appbar-hamburger.js';
import carousel360 from './carousel-360.js';
import carouselSlick from './carousel-slick.js';
import goToTop from './go-to-top.js';
import productCard from './product-card.js';
import productList from './product-list.js';
import slickItems from "./slick-items";
import productLinks from "./product_links";
import navbarToggle from "./scroll-navbar";


$(document).ready(function() {
  // Load module. TODO: Webpack autoload???
  
  const mq = window.matchMedia( "(max-width: 1150px)" );

  const onScroll = () => {
    // const section =  document.getElementsByClassName("carousel-360")[0];
    // let distance = window.pageYOffset;

  
    // if (distance >= 800) {
    //   $(section).css({
    //     'top': '-500px'
    //   });
    // } else {
    //   $(section).css({
    //     'top': ''
    //   });
    // }

  }


  const WidthChange = (mq) => {

    if (mq.matches) {

      const section = document.getElementsByClassName("carousel-360")[0];
      carouselSlick();
      window.removeEventListener("scroll", onScroll);
      $(section).css({
        'transform': `translateY(0)`
      });
    } else {
      window.addEventListener('scroll', onScroll);
    }
  }


  mq.addListener(WidthChange);
  WidthChange(mq);

  slickItems();
  accordion();
  appbarHamburger();
  carousel360();
  //carouselSlick();
  goToTop();
  productCard();
  productList();
  productLinks();
  navbarToggle();

  // window.addEventListener('scroll', () => {
  //   const section =  document.getElementsByClassName("carousel-360")[0];
  //   let distance = window.pageYOffset * 1.5;

  //   if (distance <= 0) {
  //     distance = 0;
  //   } else if(distance >= 300) {
  //     distance = 300;
  //   }

  //   $(section).css({
  //     'transform': `translateY(${distance}px)`
  //   });
  // });
});
